export enum EnumTpStatusLoja{
    Invalido = 0,
    Aberta = 1,
    Fechada = 2,
    Paralisada = 3,
    Erro  = 4
}